import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getForSearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/LogExternalService/Search",
    params
  );
  
};

const Resend = (id) => {
  const params = {
    id
  }
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/LogExternalService/Resend?userId=" +
    userData.userId(),
    params,
  )
}



export {
  getForSearch,
  Resend,
};
